import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { IntroSection } from '../components/sales/IntroSection';
import { PreviewSection } from '../components/sales/PreviewSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { NotEbookSection } from '../components/sales/NotEbookSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { ClassPrepSection } from '../components/sales/ClassPrepSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferStackSection } from '../components/sales/OfferStackSection';
import { TimeValueSection } from '../components/sales/TimeValueSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-278" data-mp="3alt79y0kl2m3">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-279" data-mp="35qx6o9h9p6xd">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-280" data-mp="30ugd2zrau0cw">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-281" data-mp="2vwez2t8qcr8a">
            Brow Instructor <span className="text-brand-gold" data-id="element-282" data-mp="3tg88zve9n9dm">Ready</span>™
          </p>
        </div>
      </header>

      <main data-id="element-283" data-mp="3ohol3pg43nim">
        <HeroSection data-id="element-284" data-mp="3jkeptt61khmv" />
        <PreviewSection data-id="element-285" data-mp="3jjn377uf9u8q" />
        <IntroSection data-id="element-286" data-mp="3jj3mtvkf7dwt" />
        <PainSection data-id="element-287" data-mp="3jmhlaspyr2yz" />
        <SolutionSection data-id="element-288" data-mp="3fitbe3duzvak" />
        <VolumesSection data-id="element-289" data-mp="3fjky0ophaiop" />
        <NotEbookSection data-id="element-290" data-mp="3fi9v0r3uxeyn" />
        <BonusesSection data-id="element-291" data-mp="3fl5tcgjma5nm" />
        <ClassPrepSection data-id="element-292" data-mp="284znsayz6zkw" />
        <AudienceSection data-id="element-293" data-mp="286arkasf87c0" />
        <OfferStackSection data-id="element-294" data-mp="286knsg427aq5" />
        <TimeValueSection data-id="element-295" data-mp="243nzq9vr2met" />
        <FaqSection data-id="element-296" data-mp="243eh57d1bhj5" />
        <FinalCtaSection data-id="element-297" data-mp="242v1jxaux58a" />
      </main>

      <SiteFooter data-id="element-298" data-mp="2460md0cgdky7" />
    </div>;
}